export const FILL_TYPES = {
  auto: 'auto',
  willCall: 'willCall',
};

export const fillTypeLabel = (type) => {
  if (type === FILL_TYPES.auto) {
    return 'Auto';
  } else if (type === FILL_TYPES.willCall) {
    return 'Will Call';
  }
  return 'Not Set';
};

export const DEVICE_STATUS = {
  partnerInventory: {
    value: 'partnerInventory',
    label: 'Partner Inventory',
    oldValue: 1,
  },
  inventory: {
    value: 'inventory',
    label: 'Inventory',
    oldValue: 2,
  },
  shipped: {
    value: 'shipped',
    label: 'Shipped',
    oldValue: 3,
  },
  installed: {
    value: 'installed',
    label: 'Installed',
    oldValue: 4,
  },
  retired: {
    value: 'retired',
    label: 'Retired',
    oldValue: 5,
  },
  qualityControl: {
    value: 'qualityControl',
    label: 'Quality Control',
    oldValue: 6,
  },
  testingLab: {
    value: 'testingLab',
    label: 'Testing Lab',
    oldValue: 7,
  },
  missing: {
    value: 'missing',
    label: 'Missing',
    oldValue: 8,
  },
  testingTeam: {
    value: 'testingTeam',
    label: 'Testing Team',
    oldValue: 9,
  },
  returned: {
    value: 'returned',
    label: 'Returned',
    oldValue: 10,
  },
  qing: {
    value: 'qing',
    label: 'Qing',
    oldValue: 11,
  },
  baja: {
    value: 'baja',
    label: 'Baja',
    oldValue: 12,
  },
  damagedBox: {
    value: 'damagedBox',
    label: 'Damaged Box',
    oldValue: 13,
    isDeprecated: true,
  },
  distributor: {
    value: 'distributor',
    label: 'Distributor',
    oldValue: 14,
  },
  toBeReflashed: {
    value: 'toBeReflashed',
    label: 'To Be Reflashed',
    oldValue: 16,
    isDeprecated: true,
  },
};

export const ERROR_CODES = {
  1: {
    value: 1,
    label: 'WiFi signal is low',
  },
  2: {
    value: 2,
    label: 'Trouble connecting to Server',
  },
  3: {
    value: 3,
    label: 'Measurement varies by more than 3"',
  },
  4: {
    value: 4,
    label: 'Measurement changed too much (>10") from last measurement',
  },
  5: {
    value: 5,
    label: 'Tank oil level increased',
  },
  6: {
    value: 6,
    label: 'Sensor has to repeat measurement',
  },
  7: {
    value: 7,
    label: 'Measurement results is more than maximum value (>75")',
  },
  8: {
    value: 8,
    label: 'Measurement is less than minimal value (<2")',
  },
  9: {
    value: 9,
    label: 'Battery level dropped below 2.5V',
  },
  10: {
    value: 10,
    label: 'Firmware failed to update',
  },
  11: {
    value: 11,
    label: 'Sensor was in setup more for more than 5 minutes.',
  },
  12: {
    value: 12,
    label: 'Sensor hardware error',
  },
  13: {
    value: 13,
    label: 'Sensor read error',
  },
  14: {
    value: 14,
    label: 'Measurement varies by more than 3"',
  },
};

export default {
  fillTypeLabel,
  DEVICE_STATUS,
  FILL_TYPES,
  ERROR_CODES,
};
